import React from 'react';
import styled from 'styled-components';
import Slider from './../../common/Slider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0px auto;

  @media (max-width: 900px) {
    margin-bottom: 0;
  }
`;

const TitleWrapper = styled.div`
  text-align: center;
  margin-top: ${ ({ titleMarginTop }) => titleMarginTop || '15px' };
  max-width: ${ ({ titleWidth }) => titleWidth || '55%' };

  @media (max-width: 900px) {
    margin-top: ${ ({ titleMarginTopMob }) => titleMarginTopMob || '15px' };
  }
`;

const TextWrapper = styled.div`
  text-align: center;
  margin-top: ${ ({ textMarginTopMob }) => textMarginTopMob || '20px' };
  max-width: 90%;

  @media (min-width: 901px) {
    max-width: ${ ({ textWidth }) => textWidth || '55%' };
    margin-top: 20px;
  }
`;

const Text = styled.p`
  @media (max-width: 900px) {
    font-size: 12px;
    line-height: 17px;
  }
`;

const Title = styled.h4`
  font-weight: 700;
  font-size: 20px;
  line-height: 1.5;

  @media (max-width: 900px) {
    font-size: 15px;
    line-height: 1.4;
  }
`;

const ImageWrapper = styled.div`
  text-align: center;
`;

const SlickWrapper = styled.div`
  overflow: hidden;
  ${ ({ fullWidth }) => (fullWidth ? 'width: 100vw;' : '') };
`;

const Image = styled.img`
  width: ${ ({ carousel }) => (carousel ? '100vw' : '80vw') };
  margin-top: 50px;

  @media (max-width: 900px) {
    margin-top: 20px;
    width: 100%;
  }
`;

export default ({
  fullWidth,
  imgSrc,
  imgSrcSet,
  title,
  text,
  carousel,
  centerPadding,
  arrows,
  darken,
  titleWidth,
  titleMarginTop,
  titleMarginTopMob,
  textMarginTopMob,
  textWidth,
  urls
}) => (
  <SlickWrapper fullWidth={ fullWidth }>
    { carousel && (
      <Slider
        urls={ urls }
        imgSrc={ imgSrc }
        imgSrcSet={ imgSrcSet }
        centerPadding={ centerPadding }
        arrows={ arrows }
        darken={ darken }
      />
    ) }
    <Container>
      { !carousel && (
        <ImageWrapper>
          <Image carousel={ carousel } src={ imgSrc } />
        </ImageWrapper>
      ) }
      { title && (
        <TitleWrapper
          titleWidth={ titleWidth }
          titleMarginTop={ titleMarginTop }
          titleMarginTopMob={ titleMarginTopMob }
        >
          <Title>{ title }</Title>
        </TitleWrapper>
      ) }
      { text && (
        <TextWrapper textWidth={ textWidth } textMarginTopMob={ textMarginTopMob }>
          <Text>{ text }</Text>
        </TextWrapper>
      ) }
    </Container>
  </SlickWrapper>
);



// WEBPACK FOOTER //
// ./src/components/products/events/ProductFeature.js